<template>
  <div class="justify-content-center text-left mt-5 dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="$router.push({ name: 'admin.samples.edit', params: { id:id } });"
                style="float:right">
        {{ $t('common.Edit') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-lg-6">
        <h2>{{ $t('entities.Sample.Singular') }} {{ customerName }}</h2>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.status') }}:</label>
          </div>
          <div class="col-lg-9">
            <SampleStatusInput v-model="status"
                               :editable="false" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('entities.Customer.Singular') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="customerName" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.updatedAt') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="updatedAtFormatted" />
          </div>
        </div>
      </div>
      <div class="text-center row col-lg-6"
           v-if="items.length > 0">
        <div class="col-12">
          <h2>{{ $t('results.CustomerViewing') }} </h2>
        </div>

        <div class="col-4">
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              class="myInput"
              type="search"
              id="filterInput"
              placeholder="Type to Search" />
            <b-input-group-append>
              <b-button :disabled="!filter"
                        @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-12">
          <div class="text-center">
            <b-table
              show-empty
              striped
              borderless
              dark
              hover
              responsive
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered" />
            <div class="col-6 offset-3">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import SampleStatusInput from '@components/input/SampleStatusInput';

export default {
  name: 'SampleViewDetail',
  components: {
    SampleStatusInput
  },
  data() {
    return {
      ready: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      filter: ''
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    updatedAtFormatted() {
      return this.$moment(this.updatedAt).format('DD.MM.YYYY HH:mm:ss');
    },
    ...mapState('sampleDetail', ['status', 'customerName', 'updatedAt']),
    ...mapState('resultCustomerDetail', ['genotypes']),
    items() {
      return this.genotypes;
    },
    fields() {
      return [{ key: 'code', label: 'Code', sortable: false }, { key: 'genotype', label: 'Genotype', sortable: false }];
    }
  },
  watch: {
    items() {
      this.totalRows = this.items.length;
    }
  },
  created() {
    this.resetContextResult();
    this.resetContextSample();
    this.setSampleId(this.id);
    this.setCustomerId(this.id);
    this.fetchSample().then(() => {
      this.ready = true;
    });
    this.fetchResult();
  },
  methods: {
    ...mapActions({ fetchSample: 'sampleDetail/fetchSample', resetContextSample: 'sampleDetail/resetContext' }),
    ...mapMutations({ setSampleId: 'sampleDetail/setSampleId', setCustomerId: 'resultCustomerDetail/setCustomerId' }),
    ...mapActions({ resetContextResult: 'resultCustomerDetail/resetContext',
      fetchResult: 'resultCustomerDetail/fetchResult' }),
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
